import { render } from "./NewsBulletins.vue?vue&type=template&id=8da5f4b4"
import script from "./NewsBulletins.vue?vue&type=script&lang=js"
export * from "./NewsBulletins.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__